/**
 * Replace .social with .nSocial
 * This is so we can style socials properly without un-styling the default
 */
(() => {
  const query = document.querySelector('.social');
  if (!query) return;

  document.querySelectorAll('.social, .nSocial').forEach((item) => {
    item.classList.remove('social');
    item.classList.add('nSocial');

    item.innerHTML = query.innerHTML;
  });
})();

/**
 * Additional JS Selectors
 */
(() => {
  // add js-target-blank class to parent to allow target blank on 'a' children
  document.querySelectorAll('.js-target-blank a').forEach((item) => {
    item.target = '_blank';
  });

  // add js-customer-tools to element to toggle customer tools slide-in
  document.querySelectorAll('.js-customer-tools').forEach((item) => {
    item.addEventListener('click', () => {
      document.querySelector('.customertools')?.classList.toggle('open');
    });
  });
})();

/**
 * Footer Links Menu Accordion
 * Add class "foot-menu" to menu widget in footer
 */
(() => {
  document.querySelectorAll('.foot-menu').forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('open');
    });
  });
})();

/**
 * make all elements with href LoginButton to open modal
 */
(() => {
  const loginButtons = document.querySelectorAll('a[href*="LoginButton"]');
  loginButtons.forEach((button) => {
    button.href = 'javascript:;';
    button.dataset.toggle = 'modal';
    button.dataset.target = '#loginModal';
  });
})();
